(function() {
	'use strict';

	angular.module('rosterStability').config(config);

	function config($stateProvider) {
		$stateProvider
				.state(
						'rosterStability',
						{
							url : '/roster-stability',
							views : {
								'rosterStabilityView' : {
									templateUrl : 'roster-stability/views/roster-stability.tpl.html',
									controller : 'RosterStabilityCtrl',
									controllerAs : 'rosterStability'
								}
							}
						});
	}
}());
